export const WORKSPACE_HOME_ROUTE_NAME = 'workspace-home';
export const CONTENT_ROUTE_NAME = 'content';
export const ASSETS_ROUTE_NAME = 'assets';
export const CONNECT_ROUTE_NAME = 'connect';
export const DATA_MODEL_ROUTE_NAME = 'data-model';
export const WORKSPACE_SETTINGS_ROUTE_NAME = 'workspace-settings';
